import { gql } from "@apollo/client";

const GET_FORUM_NOTIFICATIONS = gql`
  query GetForumNotiCount {
    me {
      unreadForumNotificationCount
    }
  }
`;
export default GET_FORUM_NOTIFICATIONS;
